import React from 'react'
import PropTypes from 'prop-types'
import PageTemplate from 'components/page-template'
import './login.css'

const Login = ({ onTwitterLoginClick, onFbLoginClick, onAuth0LoginClick }) => (
  <PageTemplate
    title='Sign In'
    description='Sign In with your Twitter or Facebook Account'
    noContainer
  >
    <div className='content'>
      <div className='br-login-platform'>
        <div className='login-form'>
          <button
            className='btn btn-block btn-social btn-x'
            id='twitter-login-button'
            onClick={onTwitterLoginClick}
          >
            <i className='fa fa-x' />
            Sign in with 𝕏
          </button>
        </div>
      </div>
      <div className='br-login-platform'>
        <div className='login-form'>
          <button
            className='btn btn-block btn-social btn-facebook'
            id='facebook-login-button'
            onClick={onFbLoginClick}
          >
            <i className='fa fa-facebook' />
            Sign in with Facebook
          </button>
        </div>
      </div>
      <div className='br-login-platform'>
        <div className='login-form'>
          <button
            className='btn btn-block btn-social btn-google'
            id='auth0-login-button'
            onClick={onAuth0LoginClick}
          >
            <i className='fa fa-google' />
            Sign in with Auth0
          </button>
        </div>
      </div>
    </div>
  </PageTemplate>
)

Login.displayName = 'Login'

Login.propTypes = {
  onTwitterLoginClick: PropTypes.func.isRequired,
  onFbLoginClick: PropTypes.func.isRequired,
  onAuth0LoginClick: PropTypes.func.isRequired
}

export default Login



// WEBPACK FOOTER //
// ./src/pages/login/index.js